import React from "react";
import MasterUserSection from "../../Sections/MasterUser";
import Dashboard from "../Dashboard/Dashboard";

const MasterUsersComponent = () => {
    return (
        <Dashboard sectionName={<MasterUserSection />}/>
    );
};

export default MasterUsersComponent;
